import { useEffect } from 'react';

/**
 * Listen to the global 'crm:refresh' event dispatched by the header refresh button.
 * Pages that want to support manual refresh should call useRefreshListener(refetchFn).
 */
export function useRefreshListener(refetchFn) {
  useEffect(() => {
    if (typeof refetchFn !== 'function') return;
    const handler = () => { try { refetchFn(); } catch (e) { /* swallow */ } };
    window.addEventListener('crm:refresh', handler);
    return () => window.removeEventListener('crm:refresh', handler);
  }, [refetchFn]);
}

export default useRefreshListener;
